// extracted by mini-css-extract-plugin
export default {"video":"StickerSetCover-module__video"};